import { isFeatureEnabled } from "./isEnabled";

/**
 * Includes item if no flags are required OR the user has access
 */
export const shouldIncludeMenuItem = (
  features: API.Features,
  props: API.SidebarMenuItem,
): boolean => {
  return (
    !props.feature_flags ||
    isFeatureEnabled(features, { or: props.feature_flags })
  );
};
